

export class Model_CRM_DomesticInternational {

    public DomesticInternational: string;
    public DomesticInternationalId: number;
    
}       

